import { CalendarDaysIcon, EyeIcon } from "@heroicons/react/24/outline";
import { StatusBadges } from "../StatusBadges";
import { formatLibraryRequestDate } from "../../utils/libraryRequestDetailsView";

const PREVIEW_BUTTON_CLASS =
  "inline-flex items-center gap-1 rounded-md px-2 py-1 text-xs font-medium text-indigo-600 hover:bg-indigo-50 hover:text-indigo-700 flex-shrink-0";

const RowValue = ({ row }) => {
  if (row.type === "status") {
    return <StatusBadges statusName={row.value} />;
  }
  if (row.type === "report") {
    return (
      <span className="flex flex-wrap items-center gap-x-4 gap-y-1">
        <span>{row.value || "-"}</span>
        {row.canPreview ? (
          <button type="button" onClick={row.onPreview} className={PREVIEW_BUTTON_CLASS}>
            <EyeIcon className="w-[16px] h-[16px]" aria-hidden="true" />
            Preview Report
          </button>
        ) : null}
      </span>
    );
  }
  if (row.type === "date") {
    return (
      <span className="flex items-center gap-x-2">
        <CalendarDaysIcon className="w-4 h-4 text-indigo-600" />
        {formatLibraryRequestDate(row.value)}
      </span>
    );
  }
  if (row.type === "badges") {
    return row.value?.length ? (
      <span className="flex flex-wrap gap-2">
        {row.value.map((name) => (
          <span
            key={name}
            className="inline-flex items-center rounded-md bg-indigo-50 px-2 py-1 text-xs font-medium text-indigo-700 ring-1 ring-inset ring-indigo-700/10"
          >
            {name}
          </span>
        ))}
      </span>
    ) : (
      "-"
    );
  }
  return row.value || "-";
};

export default function LibraryRequestOverview({ rows }) {
  return (
    <div className="divide-y divide-gray-300">
      {rows.map((row) => (
        <div key={row.key} className="px-0 py-4 sm:grid sm:grid-cols-3 sm:gap-4">
          <h2 className="text-sm font-medium text-gray-900">{row.label}</h2>
          <div className="mt-1 text-sm text-gray-700 sm:col-span-2 sm:mt-0 break-words">
            <RowValue row={row} />
          </div>
        </div>
      ))}
    </div>
  );
}
